import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAuth?: boolean; // Par défaut true
}

/**
 * Composant de protection des routes
 * Utilise le hook useAuth standard Supabase
 * Les permissions sont vérifiées côté serveur via RLS
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireAuth = true 
}) => {
  const { user, isLoading, isInitialized } = useAuth();

  // Afficher loader pendant l'initialisation
  if (!isInitialized || isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Si auth requise mais pas d'utilisateur → redirect login
  if (requireAuth && !user) {
    console.log('🚫 [ProtectedRoute] No user, redirecting to /member-access');
    return <Navigate to="/member-access" replace />;
  }

  // Utilisateur authentifié → afficher le contenu
  console.log('✅ [ProtectedRoute] User authenticated, showing content');
  return <>{children}</>;
};